var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftBoxLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139,
    height: 31.612,
    viewBox: "0 0 139 31.612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GiftBoxLogo",
    transform: "translate(-0.3 -23.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M16.2,39.821H9.44V46.01H7.06V38.679H16.2V32.3H.3V52.769H16.2V46.01h0Z",
    transform: "translate(0 -0.427)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M62.094,32.3H46.1v6.379h4.665v14.09h6.664V38.679h4.665Z",
    transform: "translate(-2.196 -0.427)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M34.455,26.732A3.413,3.413,0,0,0,30.932,23.4,3.457,3.457,0,0,0,27.6,26.827v3.427h3.427a3.558,3.558,0,0,0,3.427-3.523h0",
    transform: "translate(-1.309 0)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M27.6,32.3V52.864h6.664V46.3h7.712V39.821H34.264V38.679h9.33V32.3Z",
    transform: "translate(-1.309 -0.427)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M22.656,24.7a2.856,2.856,0,1,0,0,5.712h2.856V27.556A2.805,2.805,0,0,0,22.656,24.7h0",
    transform: "translate(-0.935 -0.063)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 6.76,
    height: 12.948,
    transform: "translate(17.818 39.394)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 6.76,
    height: 6.379,
    transform: "translate(17.818 31.873)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M70,52.674V32.3H82.662A8.542,8.542,0,0,1,87.8,33.538a4.358,4.358,0,0,1,1.714,3.713v.286c0,2.666-1.428,4.094-4.379,4.379v.1a7.06,7.06,0,0,1,4,1.428,4.371,4.371,0,0,1,1.333,3.427v.381a4.733,4.733,0,0,1-1.9,4.094c-1.333.952-3.237,1.333-5.9,1.333ZM82.091,41.344q4.57,0,4.57-3.427v-.286a3.008,3.008,0,0,0-1.142-2.571,5.682,5.682,0,0,0-3.427-.857h-9.14v7.045l9.14.1Zm.1,9.425a6.391,6.391,0,0,0,3.9-.952,3.258,3.258,0,0,0,1.238-2.856v-.19q0-3.713-5.141-3.713H72.951v7.616Z",
    transform: "translate(-3.342 -0.427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M99.922,51.893a9.787,9.787,0,0,1-4.094-3.427A9.7,9.7,0,0,1,94.4,43.134V41.8a9.6,9.6,0,0,1,1.428-5.236,9.472,9.472,0,0,1,4.094-3.427,16.065,16.065,0,0,1,6.284-1.238,14.523,14.523,0,0,1,6.284,1.238,8.587,8.587,0,0,1,4.094,3.427,9.6,9.6,0,0,1,1.428,5.236v1.333a9.926,9.926,0,0,1-1.428,5.331,9.056,9.056,0,0,1-4.094,3.427,14.523,14.523,0,0,1-6.284,1.238,15.716,15.716,0,0,1-6.284-1.238m10.949-1.9a6.586,6.586,0,0,0,3.047-2.761,7.418,7.418,0,0,0,1.047-4.189V41.9a7.239,7.239,0,0,0-4.094-6.855,11.905,11.905,0,0,0-9.33,0A7.077,7.077,0,0,0,98.494,37.8,7.3,7.3,0,0,0,97.447,41.9v1.142a8.539,8.539,0,0,0,1.047,4.189,7.724,7.724,0,0,0,3.047,2.761,10.213,10.213,0,0,0,4.665.952,10.486,10.486,0,0,0,4.665-.952",
    transform: "translate(-4.512 -0.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M123.423,52.674H119.9L129.611,42.2l-9.045-9.9h3.523l7.426,8.283,7.426-8.283h3.427l-8.854,9.9,9.521,10.473h-3.427l-8.092-8.854Z",
    transform: "translate(-5.734 -0.427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M141.636,54.344H67.852V30.257h73.784Zm.857-24.944H66.9V55.3h75.593V29.4Z",
    transform: "translate(-3.193 -0.288)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftBoxLogo);
export default __webpack_public_path__ + "static/media/GiftBoxLogo.d592f851d53c442cf62219e5fec791dc.svg";
export { ForwardRef as ReactComponent };